import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import _map from "lodash/map"
import _isEmpty from "lodash/isEmpty"
import _some from "lodash/some"
import _filter from "lodash/filter"

import { MENU_SECTION_NAVIGATION } from "shared/constants/idsElements"
import ThemeConsumer from "shared/components/ThemeConsumer"
import WrapperSkeleton from "components/WrapperSkeleton"
import MenuItem from "./MenuItem"

import { items } from "./menu"
import { isItemVisible } from "./isItemVisible"

import {
  getSVAs,
  getProducts,
  getValidateConglomerates,
  validateBeegolAccessAvailability,
  saveOperation
} from "services/state/actions"
import { useSVAStatus } from "hooks/useSVAStatus"
import { useBeegolAccessAvailability } from "hooks/useBeegolAccessAvailability"

const Menu = ({
  theme,
  icons,
  currentPath,
  customer,
  getSVAs,
  svas,
  products,
  getProducts,
  getValidateConglomerates,
  validateBeegolAccessAvailability,
  saveOperation,
  permissions
}) => {
  const mainMenuPermissions = permissions.data.mainMenu
  const showOnlineInterface = useSVAStatus(customer, getSVAs)

  const [isMonitoring, setIsMonitoring] = useState(false)
  const beegolAccess = useBeegolAccessAvailability(
    customer,
    validateBeegolAccessAvailability
  )

  useEffect(() => {
    if (_isEmpty(products.data)) {
      getProducts()
    }
  }, [])

  useEffect(() => {
    getValidateConglomerates().then((response) => {
      if (response.payload && response.payload.data) {
        setIsMonitoring(response.payload.data.navaPortal)
      }
    })
  }, [])

  return (
    <WrapperSkeleton
      path="menuNavegation"
      isChildrenReady={
        !_isEmpty(customer) && !svas.loading && !permissions.loading
      }
    >
      <nav id={MENU_SECTION_NAVIGATION} className={theme.container}>
        <ul>
          {_map(
            _filter(items(showOnlineInterface), (item) =>
              isItemVisible(item, {
                mainMenuPermissions,
                products,
                beegolAccess,
                customer,
                isMonitoring
              })
            ),
            (item, index) => {
              const rawSubItems = item.subItems || []
              const visibleSubItems = _filter(rawSubItems, (subItem) =>
                isItemVisible(subItem, {
                  mainMenuPermissions,
                  products,
                  beegolAccess,
                  customer,
                  isMonitoring
                })
              )

              if (item.showSubItems && !visibleSubItems.length) return null

              const hasNewMenu = _some(visibleSubItems, "isNew")

              return (
                <MenuItem
                  iconComponent={icons[item.icon]}
                  arrowIcon={icons.Arrow}
                  key={item.name + index}
                  currentPath={currentPath}
                  isMonitoring={isMonitoring}
                  hasNewMenu={hasNewMenu}
                  products={products}
                  beegolAccess={beegolAccess}
                  customer={customer}
                  saveOperation={saveOperation}
                  {...item}
                  subItems={item.showSubItems ? visibleSubItems : item.subItems}
                />
              )
            }
          )}
        </ul>
      </nav>
    </WrapperSkeleton>
  )
}

Menu.propTypes = {
  theme: PropTypes.shape({
    container: PropTypes.string,
    containerCta: PropTypes.string,
    ph3: PropTypes.string,
    pv4: PropTypes.string,
    w100: PropTypes.string,
    mt3: PropTypes.string
  }),
  icons: PropTypes.object,
  currentPath: PropTypes.string,
  customer: PropTypes.object,
  getSVAs: PropTypes.func,
  svas: PropTypes.object,
  products: PropTypes.object,
  getProducts: PropTypes.func,
  getValidateConglomerates: PropTypes.func,
  validateBeegolAccessAvailability: PropTypes.func,
  saveOperation: PropTypes.func,
  permissions: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.shape({
      mainMenu: PropTypes.array
    })
  })
}

const mapStateToProps = ({ customer, svas, products, permissions }) => ({
  customer: customer.data,
  svas,
  products,
  permissions
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    getSVAs,
    getProducts,
    getValidateConglomerates,
    validateBeegolAccessAvailability,
    saveOperation
  })
)

export default enhance(ThemeConsumer("UIMenu")(Menu))



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Menu/index.js